// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.DateTimeInput {
    position: relative;
}

div.DateTimeInput > input[type=date] {
    min-width: 16ch;
}

div.DateTimeInput > input[type=time] {
    min-width: 11ch;
}

div.DateTimeInput > input[type=text] {
    position: absolute;
    inset: 0;
    z-index: -10000;
}`, "",{"version":3,"sources":["webpack://./components/widgets/style/DateTimeInput.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;AACnB","sourcesContent":["div.DateTimeInput {\n    position: relative;\n}\n\ndiv.DateTimeInput > input[type=date] {\n    min-width: 16ch;\n}\n\ndiv.DateTimeInput > input[type=time] {\n    min-width: 11ch;\n}\n\ndiv.DateTimeInput > input[type=text] {\n    position: absolute;\n    inset: 0;\n    z-index: -10000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
